import * as PropTypes from "prop-types"
import styled from "styled-components"
import { useLocale, useT } from "react-polyglot-hooks"
import { printNumber } from "helpers/formatter"
import isEmpty from "lodash/isEmpty"
import Typography from "components/styled/Typography"
import { useContext } from "react"
import { CarContext } from "scenes/CarScene/CarContext"

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(10px, 1fr));
  gap: 5px;
  padding: 15px;
  border-radius: 12px;
  background-color: rgba(11, 158, 217, 0.2);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
`

const Name = styled.div`
  white-space: nowrap;
  overflow: hidden;

  > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h3 {
    font-size: 21px;
    line-height: 1.5;
  }

  p {
    font-size: 14px;
    line-height: 21px;
  }
`

const PlanBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
`

const Price = styled(Typography)`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  font-size: 21px;
  line-height: 30px;

  span {
    font-size: 14px;
    line-height: 30px;
    margin-left: 5px;
  }
`

const DownPayment = styled(Typography)`
  margin: -5px 0 5px;
  font-style: italic;
`

const PlanInfo = styled(Typography)`
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

function CarData({ car, selectedPlan }) {
  const t = useT()
  const locale = useLocale()

  const { withoutTaxes } = useContext(CarContext)

  const { brand, model, version, downPayment } = car
  const hasPlan = !isEmpty(selectedPlan)

  return (
    <Wrapper>
      <Name>
        <Typography variant="title3" weight="medium" color="white" className="m-0">
          {`${brand} ${model}`}
        </Typography>
        <Typography color="white">{`${version}`}</Typography>
      </Name>
      {hasPlan && (
        <PlanBox>
          <Price variant="title2" weight="bold" color="skyBlue">
            {withoutTaxes ? selectedPlan.priceWithoutTaxes : selectedPlan.price}
            <Typography variant="title4" weight="bold" el="span" color="skyBlue">
              {t("common.currency")}
            </Typography>
          </Price>
          {locale === "it" && (
            <DownPayment variant="small" color="skyBlue">
              {downPayment ? t("common.down_payment", { downPayment }) : t("common.without_down_payment")}
            </DownPayment>
          )}
          <PlanInfo color="white">
            {t("common.plan_short", { km: printNumber(selectedPlan.kmYear), duration: selectedPlan.duration })}
          </PlanInfo>
        </PlanBox>
      )}
    </Wrapper>
  )
}

CarData.propTypes = {
  car: PropTypes.object.isRequired,
  selectedPlan: PropTypes.object.isRequired
}

export default CarData
